import {Component, ElementRef, Input, OnDestroy, OnInit} from "@angular/core";
import {FUIOptionsService, SelectionEvent} from "../../framework/options.service";
import {FUIAbstractOptions} from "../../framework/abstract-options";
import {Subscription} from "rxjs";
import {FUIOptionMetaData} from "./option-meta-data";

@Component({
    selector: "fui-select-options",
    styleUrls: ["./select-options.component.scss"],
    templateUrl: "./select-options.component.html",
    standalone: false
})
export class FUISelectOptionsComponent extends FUIAbstractOptions implements OnInit, OnDestroy {
    @Input() getOptionMetaData: (option: any) => FUIOptionMetaData = () => undefined;

    @Input() optionElementHandler: (option: any, elementRef: ElementRef) => void;

    private _$selection: Subscription;
    extendedOptions: Array<ExtendedOption> = [];

    constructor(optionsService: FUIOptionsService) {
        super(optionsService);
        this._$selection = this.optionsService.selection$.subscribe(
            (event: SelectionEvent) => {
                this.selection = event.selection;
                this.selection$.emit(event);
            }
        )
    }

    ngOnInit(): void {
        this.populateExtendedOptions();
    }

    ngOnDestroy(): void {
        this._$selection.unsubscribe;
    }

    /**
     * Set the selection selected to null
     */
    public unselect(): void {
        this.optionsService.selection = null;
    }

    /**
     * Intercepts the setting of filtered options to populate the extendedOptions array which includes the meta data for each option,
     * and tracks the group headings.
     * @param filteredOptions
     */
    protected override setFilteredOptions(filteredOptions: Array<any>): void {
        super.setFilteredOptions(filteredOptions);
        this.populateExtendedOptions();
    }

    private populateExtendedOptions(): void {
        this.extendedOptions = [];
        let groupHeading: string;
        this.filteredOptions.forEach(option => {
            let meta: FUIOptionMetaData = this.getOptionMetaData(option);
            if (!meta) {
                meta = new FUIOptionMetaData({});
            } else if (meta.groupHeading === groupHeading) {
                meta = new FUIOptionMetaData({
                    icon: meta.icon
                });
            } else {
                groupHeading = meta.groupHeading;
            }
            this.extendedOptions.push(new ExtendedOption({
                data: option,
                meta: meta
            }));
        });
    }
}

export class ExtendedOption {
    data: any;
    meta: FUIOptionMetaData;

    constructor(extendedOption?: any) {
        this.data = extendedOption && extendedOption.data || null;
        this.meta = extendedOption && extendedOption.meta || null;
    }
}
